import { useGetCatalogRootCurationHeroHeaderQuery } from '../../CurationHeroHeader.graphql.generated';
import { useMemo, useRef } from 'react';
import type { CurationHeroHeaderCuration, RawCatalogEntityCuration } from '../../CurationHeroHeader.types';
import { useShopStorefrontContext } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';

type UseCurationHeroHeaderDataArgs = {
  eventId: Maybe<string>;
};

const isValidCurationObject = (val: RawCatalogEntityCuration): val is CurationHeroHeaderCuration => {
  return !!val?.header;
};

export const useCurationHeroHeaderData = ({ eventId }: UseCurationHeroHeaderDataArgs) => {
  const { currentStorefront } = useShopStorefrontContext();
  const { data, loading } = useGetCatalogRootCurationHeroHeaderQuery({ batchMode: 'fast', variables: { eventId, storefront: currentStorefront } });
  const fetchedData = useRef<CurationHeroHeaderCuration[]>([]);

  const curations = useMemo<CurationHeroHeaderCuration[]>(() => {
    const curationItems: CurationHeroHeaderCuration[] = [];
    data?.recommendCatalogHomeSections.sections[0]?.catalogEntities.forEach(entity => {
      if (entity.__typename === 'ProductCatalogEntityCuration' && isValidCurationObject(entity.catalogCurationData)) {
        curationItems.push(entity.catalogCurationData);
      }
    });

    if (curationItems.length) {
      fetchedData.current = curationItems;
    }
    return fetchedData.current;
  }, [data]);

  return {
    curations,
    loading,
  };
};
